exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".topics-1{fill:#faedb1}.topics-2{fill:#e5e5e5}.topics-3{fill:#1e4e69}.topics-4{fill:#a6b1b9}\n", ""]);
